'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESTORE_SUCCESS = exports.DESTROY_SUCCESS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.archive = archive;
exports.decline = decline;
exports.destroy = destroy;
exports.forceReload = forceReload;
exports.getNotification = getNotification;
exports.isLoaded = isLoaded;
exports.load = load;
exports.newNotification = newNotification;
exports.publish = publish;
exports.restore = restore;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'caligram/notifications/LOAD';
var LOAD_SUCCESS = 'caligram/notifications/LOAD_SUCCESS';
var LOAD_FAIL = 'caligram/notifications/LOAD_FAIL';
var NOTIFICATION_LOAD_SUCCESS = 'caligram/notifications/NOTIFICATION_LOAD_SUCCESS';
var NOTIFICATION_LOAD_FAIL = 'caligram/notifications/NOTIFICATION_LOAD_FAIL';
var NOTIFICATION_NEW = 'caligram/notifications/NOTIFICATION_NEW';
var SAVE = 'caligram/notifications/SAVE';
var SAVE_SUCCESS = 'caligram/notifications/SAVE_SUCCESS';
var SAVE_FAIL = 'caligram/notifications/SAVE_FAIL';
var DESTROY = 'caligram/notifications/DESTROY';
var DESTROY_SUCCESS = exports.DESTROY_SUCCESS = 'caligram/notifications/DESTROY_SUCCESS';
var DESTROY_FAIL = 'caligram/notifications/DESTROY_FAIL';
var RESTORE = 'caligram/notifications/RESTORE';
var RESTORE_SUCCESS = exports.RESTORE_SUCCESS = 'caligram/notifications/RESTORE_SUCCESS';
var RESTORE_FAIL = 'caligram/notifications/RESTORE_FAIL';
var FORCE_RELOAD = 'caligram/notifications/FORCE_RELOAD';

var initialState = {
  loaded: false,
  saving: false,
  saveError: {},
  destroyed: null,
  notifications: {
    data: [],
    pagination: {
      current_page: 0,
      total: 0,
      total_pages: 0
    }
  },
  notification: {},
  queryParams: {
    page: 1
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  function removeNotification(id) {
    var index = 0;
    var notifications = state.notifications.data;

    for (index = 0; index < notifications.length; index++) {
      if (notifications[index].id === id) {

        return notifications;
      }
    }
    return notifications;
  }

  function destroyedNotification(id) {
    var index = 0;
    var notifications = state.notifications.data;

    for (index = 0; index < notifications.length; index++) {
      if (notifications[index].id === id) {
        var destroyed = notifications.splice(index, 1);
        return destroyed[0];
      }
    }
    return null;
  }

  function restoreNotification() {
    var notifications = state.notifications.data;
    var destroyed = state.destroyed;

    notifications.unshift(destroyed);
    return notifications;
  }

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, {
        loading: false,
        loaded: true,
        notifications: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, {
        loading: false,
        loaded: false,
        notifications: null,
        error: action.error
      });
    case NOTIFICATION_NEW:
      return (0, _extends6.default)({}, state, {
        loading: false,
        loaded: false,
        event: initialState.event,
        error: null
      });
    case NOTIFICATION_LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, {
        loading: false,
        loaded: true,
        event: action.result,
        error: null
      });
    case NOTIFICATION_LOAD_FAIL:
      return (0, _extends6.default)({}, state, {
        loading: false,
        loaded: false,
        event: null,
        error: action.error
      });
    case DESTROY:
      return (0, _extends6.default)({}, state, {
        loading: true
      });
    case DESTROY_SUCCESS:
      return (0, _extends6.default)({}, state, {
        destroyed: destroyedNotification(action.id),
        notifications: {
          data: removeNotification(action.id)
        },
        loading: false
      });
    case DESTROY_FAIL:
      return (0, _extends6.default)({}, state, {
        loading: false
      });
    case RESTORE:
      return (0, _extends6.default)({}, state, {
        loading: true
      });
    case RESTORE_SUCCESS:
      return (0, _extends6.default)({}, state, {
        destroyed: null,
        notifications: {
          data: restoreNotification()
        },
        loading: false
      });
    case RESTORE_FAIL:
      return (0, _extends6.default)({}, state, {
        loading: false
      });
    case FORCE_RELOAD:
      return (0, _extends6.default)({}, state, {
        loaded: false
      });
    case SAVE:
      return (0, _extends6.default)({}, state, {
        saving: true
      });
    case SAVE_SUCCESS:
      return (0, _extends6.default)({}, state, {
        saving: false,
        saveError: (0, _extends6.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, null))
      });
    case SAVE_FAIL:
      return typeof action.error === 'string' ? (0, _extends6.default)({}, state, {
        saving: false,
        saveError: (0, _extends6.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, action.error))
      }) : (0, _extends6.default)({}, state, {
        saving: false,
        saveError: (0, _extends6.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, action.error))
      });

    default:
      return state;
  }
}

// Archive notification
function archive(id) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.del('/notifications/' + id);
    }
  };
}

// decline
function decline(id, message) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.put('notifications/' + id + '/decline', {
        data: { message: message }
      });
    }
  };
}

// Destroy notification
function destroy(id) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.del('/notifications/archived/' + id);
    }
  };
}

function forceReload(id) {
  return { type: FORCE_RELOAD, id: id };
}

// Single event
function getNotification(id) {
  if (id) {
    return {
      types: [LOAD, NOTIFICATION_LOAD_SUCCESS, NOTIFICATION_LOAD_FAIL],
      promise: function promise(client) {
        return client.get('/notifications/' + id);
      }
    };
  }
}

function isLoaded(globalState) {
  return globalState.notifications && globalState.notifications.loaded;
}

function load(queryString) {
  var archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var url = archived ? '/notifications/archived?' : '/notifications?';
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(url + _queryString2.default.stringify(queryString));
    }
  };
}

function newNotification() {
  return {
    type: NOTIFICATION_NEW
  };
}

// publish
function publish(id) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.put('notifications/' + id + '/publish');
    }
  };
}

// Restore notification
function restore(id) {
  return {
    types: [RESTORE, RESTORE_SUCCESS, RESTORE_FAIL],
    id: id,
    promise: function promise(client) {
      return client.put('notifications/archived/' + id + '/restore');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/notifications.js
// module id = 997
// module chunks = 0